import React, {useState, useEffect} from "react";
import EditPronunciationComponent from "./EditPronunciationComponent";
import firebase from "firebase";
import {storage} from "../../../firebase";
import _ from 'lodash'
import StepTwoAddPronunciation from "./StepTwoAddPronunciation";
import axios from "axios";

function StepOneAddPronunciation(
    {
        assignment,
        editAssignment,
        setEditAssignmentLoading,
        setEditAssignmentProgress,
        actionChoice,
        databaseChoice
    }
) {

    const [sounds, setSounds] = useState([]);
    const [soundsList, setSoundsList] = useState([]);
    const [error, setError] = useState('');
    const [fileNames, setFilenames] = useState([]);
    const [progress, setProgress] = useState(0);
    const [addPronunciation, setAddPronunciation] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editSoundProgress, setEditSoundProgress] = useState(0);
    const [editSoundLoading, setEditSoundLoading] = useState(false);
    const [editSoundNames, setEditSoundNames] = useState([]);
    const [assignmentName, setAssignmentName] = useState('')

    useEffect(() => {
        setLoading(false);
        let tmpFileNames = [];
        firebase.storage().ref().child('sounds').listAll()
            .then((data) => {
                data.items.forEach((folderRef) => {

                    tmpFileNames.push(folderRef.location.path_.split('/')[1])
                })
            }).catch(e => console.log(e));
        setFilenames(tmpFileNames)

        async function fetchAssignmentData() {
            setSoundsList([]);
            setEditSoundNames([]);
            setEditAssignmentLoading(true);
            setEditSoundLoading(true);
            const fetchedAssignment = await firebase.storage().ref().child('assignments/Samoan101/pronunciationAssignments/' + assignment);
            await fetchedAssignment.getDownloadURL()
                .then((url) => axios.get(url))
                .then(res => {
                    async function setData(data) {
                        for(let i = 0; i < data.length; i++){
                            setEditSoundNames(prevState => [...prevState,data[i].name]);
                            const retrievedSound = firebase.storage().ref().child('sounds/' + data[i].file);
                            await retrievedSound.getDownloadURL()
                                .then(url=>{
                                    fetch(url)
                                        .then(res=>res.blob())
                                        .then(blob=>{
                                            let file = new File([blob], data[i].file);
                                            setSoundsList(prevState => [...prevState, file]);
                                            setEditAssignmentProgress(prevState => prevState + Math.round(100/data.length));
                                            setEditSoundProgress(prevState => prevState + Math.round(100/data.length))

                                        })
                                })
                        }
                    }

                    setData(res.data).then(()=>console.log('ready'))
                });
        }

        if (editAssignment) {
            setAssignmentName(assignment);
            fetchAssignmentData().then(()=>{
                setEditAssignmentLoading(false);
                setEditAssignmentProgress(0)
            })
        }
    }, [editAssignment, actionChoice, databaseChoice]);

    const handleUpload = async () => {
        for (let i = 0; i < soundsList.length; i++) {
            const uploadTask = storage.ref(`sounds/${soundsList[i].name}`).put(soundsList[i]);
            uploadTask.on(
                "state_changed",
                () => {
                },
                error => {
                    console.log(error)
                },
                () => {
                    storage
                        .ref("sounds")
                        .child(soundsList[i].name)
                        .getDownloadURL()
                        .then(() => {
                                setProgress(prevState => prevState + Math.round(100 / soundsList.length));
                                setLoading(true);
                            }
                        ).catch(e => {
                        setError('There has been a problem uploading the sounds provided');
                        setLoading(false)
                    })
                }
            )

        }

    };

    if(editSoundProgress >= 90)
    {
        setEditSoundLoading(false);
        setEditSoundProgress(0);
    }

    if(progress >= 90){
        setAddPronunciation(true);
        setProgress(0)
    }

    const handleSaveSounds = () => {
        let tmpSoundsList = [];
        for (let i = 0; i < sounds.length; i++) {
            let tmpSound = new File([sounds[i]], 'pronunciation_' + sounds[i].name);
            tmpSoundsList.push(tmpSound);
        }

        setSoundsList(prevState => _.flatten([...prevState, tmpSoundsList]));
        setSounds([])
    };

    const handleChange = (e) => {
        let tmpSounds = [];
        if (e.target.files) {
            for (let i = 0; i < e.target.files.length; i++) {
                tmpSounds.push(e.target.files[i])
            }
            setSounds(tmpSounds)
        }
    };

    const handleDeleteItem = (indexNum) => {
        let tmpSoundsList = soundsList;
        let tmpEditSoundNames = editSoundNames;
        tmpSoundsList.splice(indexNum, 1);
        if(tmpEditSoundNames){
            tmpEditSoundNames.splice(indexNum, 1);
        }
        setSoundsList(() => [...tmpSoundsList]);
        setEditSoundNames(()=>[...tmpEditSoundNames]);

    };

    const handleBackToSounds = () => {
        setAddPronunciation(false)
    };

    const handleClearData = () => {
        setSounds([]);
        setSoundsList([]);
        setError('');
        setProgress(0);
        setLoading(false);
        setEditSoundProgress(0);
        setEditSoundLoading(false);
        setEditSoundNames([]);
        let tmpFileNames = [];
        firebase.storage().ref().child('sounds').listAll()
            .then((data) => {
                data.items.forEach((folderRef) => {

                    tmpFileNames.push(folderRef.location.path_.split('/')[1])
                })
            }).catch(e => console.log(e));
        setFilenames(tmpFileNames)
    };


    return (
        <>
            {
                addPronunciation ?
                    <StepTwoAddPronunciation
                        soundsList={soundsList}
                        handleBackToSounds={handleBackToSounds}
                        editSoundNames={editSoundNames}
                        editAssignment={editAssignment}
                        assignmentName={assignmentName}
                    />
                    :
                    <EditPronunciationComponent
                        handleSaveSounds={handleSaveSounds}
                        soundsList={soundsList}
                        handleDeleteItem={handleDeleteItem}
                        handleChange={handleChange}
                        handleUpload={handleUpload}
                        error={error}
                        progress={progress}
                        loading={loading}
                        editSoundLoading={editSoundLoading}
                        editSoundProgress={editSoundProgress}
                        handleClearData={handleClearData}
                        editAssignment={editAssignment}
                        assignment={assignment}
                    />
            }

        </>
    )
}

export default StepOneAddPronunciation
